export default __webpack_public_path__ + "static/media/galleries.a595362d.png";